exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--ZJcwf {\n  padding: 5px;\n}\n\n.header--2ztSx {\n  padding: 5px;\n  color: #383838;\n}\n\n.content--2iGMH {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--ZJcwf",
	"header": "header--2ztSx",
	"content": "content--2iGMH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/cards/limits/LimitGroup/LimitGroup.m.scss
// module id = 1396
// module chunks = 0